import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { aiGovernanceAccessPermission } from '@internal/backstage-plugin-ai-gra-common';

import { AiGraApiClient } from './api/AiGraApiClient';
import { aiGraApiRef } from './api/aiGraApiRef';
import { rootRouteRef } from './routes';

const aiGraApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: aiGraApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiGraApiClient(discoveryApi, fetchApi),
    }),
});

/**
 * The permission check lives here rather than in the app's route tree: the new
 * frontend system does not support wrapping routes in `RequirePermission`, so
 * plugins gate their own pages.
 */
const aiGovernancePage = PageBlueprint.make({
  params: {
    path: '/ai-governance',
    routeRef: rootRouteRef,
    // These pages render their own Header; suppress the default plugin page header.
    noHeader: true,
    loader: () =>
      import('./components/AiGraPage').then(m => (
        <RequirePermission permission={aiGovernanceAccessPermission}>
          <m.AiGraPage />
        </RequirePermission>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'ai-gra',
  routes: {
    root: rootRouteRef,
  },
  extensions: [aiGraApi, aiGovernancePage],
});
